import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=032befc5&scoped=true&"
import script from "./CompanyList.vue?vue&type=script&lang=js&"
export * from "./CompanyList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=032befc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032befc5",
  null
  
)

export default component.exports